import { render } from "./EventsDetailsPage.vue?vue&type=template&id=1df36caf&ts=true"
import script from "./EventsDetailsPage.vue?vue&type=script&lang=ts"
export * from "./EventsDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__